import { render, staticRenderFns } from "./serviceStorageConfig.vue?vue&type=template&id=9a2cb1e4&"
import script from "./serviceStorageConfig.vue?vue&type=script&lang=js&"
export * from "./serviceStorageConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports